export const FILE = 'file';
export const FILE_UPLOAD = 'file-upload';
export const ONLINE = 'online';
export const OFFLINE = 'offline';
export const PREVIEW = 'link-preview';
